import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import { animated, useTransition } from "@react-spring/web";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/actions/users";

import _ from "lodash";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import EventService from "../../utils/event.service.jsx";
import AssetView, { LiteAssetView } from "../../pages/asset";
import StreamView from "../../pages/streams/index";
import Slider from "../slider";
import Hub from "../../pages/hub";
import LogIn from "../../pages/anonymous/login";
import Reports from "src/pages/reports";
import PerformanceReport from "src/pages/reports/components/performance";
import DiscoveryReport from "src/pages/reports/components/discovery";
import EngagementReport from "src/pages/reports/components/engagement";
import { isAuthenticated } from "../../utils/authentication.service";

import SearchPage from "src/legacy/pages/search/SearchPage";
import DetailedSearchPage from "src/legacy/pages/search/DetailedSearchPage";
import HubSearchPage from "src/legacy/pages/hubSearch/SearchPage";
import HubDetailedSearchPage from "src/legacy/pages/hubSearch/DetailedSearchPage";
import StreamSearchPage from "src/legacy/pages/streamSearch/SearchPage";
import StreamDetailedSearchPage from "src/legacy/pages/streamSearch/DetailedSearchPage";

import { localizedStrings } from "../../localization/index.jsx";
import { CollectionsPage, CollectionsGrid } from "../../pages/collections";
import { IKContext } from "imagekitio-react";
import GroupView from "../../pages/groups";
import { Bounce, ToastContainer } from "react-toastify";

import { hideSideMenu as hideSideMenuDispath  } from "src/redux/actions/hub";
import "react-toastify/dist/ReactToastify.css";
import "../../index.scss";
import styles from "./app.module.scss";
import { fetchAccount } from "../../redux/actions/accounts";
import AppServices from "../appServices";
import userRoleService from "../../utils/userRoles.service.js";
import subscriptionPlanService from "../../utils/subscriptionPlan.service.js";
import { MainMenu } from "./components/menu/";
import { CollectionPage } from "../../pages/collection";
import MicrosoftWopiIntegration from "src/pages/asset/office";
import GDocEditor from "src/pages/asset/gdocs/edit";
import GDocEditorProcessing from "src/pages/asset/gdocs/sync";
import DocusignSigningComplete from "src/pages/asset/docusign/signingComplete";
import CreateAsset from "src/pages/createAsset";
import Conversations from "src/pages/conversations";
import PrivacyPolicy from "src/legacy/pages/settings/PrivacyPolicy";
import TermsAndConditions from "src/legacy/pages/settings/TermsAndConditions";
import PrivacyView from "src/legacy/pages/anonymous/legal/PrivacyView";

import ContentMap from "src/pages/contentMap";
import cx from "classnames";
import DealInsightsDashboard from "src/pages/dealInsights/dashboard";
import DealDetailsView from "src/pages/dealInsights/dealDetails/index";
import ProfilePage from "src/legacy/pages/settings/profile";
import DataSourcePage from "src/legacy/pages/settings/dataSource/DataSourcePage";
import DealRooms from "src/pages/dealRooms/index"
import { EditConversationPage } from "src/pages/conversations/edit";
import { BackgroundUploadTaskManager } from "../asset/backgroundTask";
import { fetchActivatedWorkSpaces } from "src/redux/actions/cleverstory";
import Seek from "src/pages/seek";
import { toggleSeek } from "src/redux/actions/seek";
import AnonymousView from "src/pages/anonymous";
import SSOFailure from "src/pages/anonymous/ssoFailure";
import ForgotPassword from "src/pages/anonymous/forgotPassword";
import ActivateAccount from "src/pages/anonymous/activateAccount";
import Activation from "src/pages/anonymous/activation";
import ResetPassword from "src/pages/anonymous/resetPassword";
import VerifyPhone from "src/pages/anonymous/verifyPhone";
import AcceptInvitation from "src/pages/anonymous/acceptInvitation";
import SignInAs from "src/pages/anonymous/signInAs";
import { Account } from "src/types/accounts";
import { UncategorizedCollectionPage } from "src/pages/collection/uncategorized";
import hasAccess from "src/utils/hasAccess.service";
import EmptyMessage from "../emptyMessage";
import PageNotFound from "../pageNotFound";
import { CoachingPage } from "src/pages/coaching";
import ComposePage from "../compose/components/page";
import GradientBackground from "../gradientBackground";
import { SSOSuccess } from "src/pages/anonymous/ssoSuccess";
import Home from "src/pages/home";
import ContactConversationsContainer from "src/legacy/lite/contactConversations";
import HubspotContactConversationsContainer from "src/legacy/lite/hubspot/contact/shares/index";
import OpportunitySharesContainer from "src/legacy/lite/opportunities";
import OpportunityRecommendedAssetsContainer from "src/legacy/lite/opportunities/recommendedAssets";
import OpportunityRecommendedStreamContainer from "src/legacy/lite/opportunities/recommendedStream";
import MsDynamicsOpportunityRecommendedAssetsContainer from "src/legacy/lite/opportunities/msDynamicsRecommendedAssets";
import UniqueViewersContainer from "src/legacy/lite/reports/uniqueViewer";
import ShareViewContainer from "src/legacy/lite/reports/shareView";
import AssetViewContainer from "src/legacy/lite/reports/assetView";
import LeadViewContainer from "src/legacy/lite/reports/leadView";
import AssetShareAnalyticsContainer from "src/legacy/lite/assetShareAnalytics";
import OpportunityAssetShareAnalyticsContainer from "src/legacy/lite/opportunityAssetShareAnalytics";
import Opportunities from "src/legacy/lite/opportunitiesContainer";
import ScenarioPage from "src/pages/coaching/sceanrios/components/scenario";
import Helmet from 'react-helmet';
import ReferralRedirectView from "src/pages/referral";
import UnsubscribePage from "src/legacy/pages/settings/unsubscribe/UnsubscribePage";
import SettingsRoutes from "src/pages/settings/routes";
import AdvocacyTab from "src/pages/reports/components/advocacy";

import DealRoom from "src/pages/dealRoom";
import AssetsPage from "src/pages/dealRoom/pages/assets";
import OverView from "src/pages/dealRoom/pages/overview";
import PeoplePage from "src/pages/dealRoom/pages/people";
import ActivityPage from "src/pages/dealRoom/pages/activity";
import ActionPlanPage from "src/pages/dealRoom/pages/actionPlan";
import AppContextProvider from "./contexts/appContext";
import MicrosoftWopiIntegrationProcessingPage from "src/pages/asset/office/sync"
import RecommendedAssets from "src/pages/lite/recommendedAssets/index";
import HubspotOpportunitySharesContainer from "src/legacy/lite/hubspot/opportunity/conversations/shares";
import { TourWatcher } from "../tour/tour.watcher";

import DealRoomEngagePage from "src/pages/dealRoom/pages/engage";
import EngagePage from "src/pages/engage/index";
// eslint-disable-next-line no-undef
const imageCDNUrl = process.env.REACT_APP_IMAGE_CDN;

function App() {
  const queryClient = new QueryClient();
  EventService.initialiseMixpanel();

  useEffect(() => {
    localizedStrings.setLanguage("en");

  }, []);

  const url = window.location.pathname;
  const isLiteApp = url.startsWith("/lite");

  return (
    <>
      <QueryClientProvider client={queryClient}>

      <IKContext urlEndpoint={imageCDNUrl}>

        <Router basename={isLiteApp ? "/lite" : ""}>
          <Routes>
            <Route path="/" element={<AnonymousView />}>
              <Route path="/__login__/:id" element={<SignInAs/>}/>
              <Route path="/public/login" element={<LogIn />} />
              <Route path="/sso/success" element={<SSOSuccess />} />
              <Route path="/sso/failure" element={<SSOFailure />} />
              <Route
                path="/privacy"
                element={<PrivacyPolicy />}
              />
              <Route path="/unsubscribe/:contactId"
                element={<UnsubscribePage />} />
              <Route
                path="/terms"
                element={<TermsAndConditions />}
              />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:id" element={<ResetPassword />} />
              <Route path="/verify-phone" element={<VerifyPhone />} />

              <Route
                path="/registration/activate/:id"
                element={<ActivateAccount />}
              />
              <Route path="/invitation/:id" element={<AcceptInvitation/>} />
            </Route>
            <Route path="/logout" element={<AnonymousView/>} />
            <Route path="/*" element={<ApplicationRoutes isLiteApp={isLiteApp} /> } />
            <Route path="/activate/success" element={<Activation />} />
          </Routes>
        </Router>

          { process.env.REACT_APP_ENVIRONMENT === "LOCAL" && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}

        </IKContext>
      </QueryClientProvider>
    </>
  );
}

const ApplicationRoutes = ({ isLiteApp }: {
  isLiteApp: boolean,
}) => {
  const authenticated = isAuthenticated();
  const location = useLocation();
  if (isLiteApp && !authenticated) {
    return (
      <Routes>
        <Route path="/*" element={<Navigate to={`/public/login?redirect=${location.pathname}`} />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {isLiteApp && getLiteAppRoutes()}
      <Route path="/*" element={<AuthenticatedApplication/>}/>
    </Routes>
  )
}

const AuthenticatedApplication = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showComponent, setShowComponent] = useState(false);
  const [showSeek, setShowSeek] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [activeModule, setActiveModule] = useState("");

  const authenticated = isAuthenticated();

  const user = useSelector((state: any) => _.get(state, 'users.me'));
  const seek = useSelector((state: any) => _.get(state, 'seek.success')) || false;
  const seekSessionChats = useSelector((state: any) => _.get(state, 'seek.session.item.chats')) || [];
  const account = useSelector((state: any) => _.get(state, 'accounts.item'));
  const hideSideMenu = useSelector((state: any) => _.get(state, 'hub.hideSideMenu')) || showComponent;
  const isCleverStoryIntegrated = _.get(account,"cleverstoryIntegration")
  const activatedWorkSpaces = useSelector((state:any) => _.get(state,"cleverStory.activatedWorkSpaces.items"))

  const url = window.location.pathname;
  const isLiteApp = url.startsWith("/lite");
  const isLiteAssetView = _.includes(url, "liteAssetView");

  useEffect(() => {
    if (authenticated) {
      dispatch(fetchUserProfile());
      dispatch(fetchAccount());
    }
  }, [authenticated]);

  useEffect(() => {
    const pathname = location.pathname.split("/")[1];
    setActiveModule(pathname);

    if (
      location.pathname.startsWith("/settings/integrations/") &&
      !_.isEmpty(_.split(location.pathname, "/").slice(3))
    ) {
      dispatch(hideSideMenuDispath(true));
    }
    else if (location.pathname === "/settings/integrations") {
      dispatch(hideSideMenuDispath(false));
    }
  }, [location.pathname]);

  useEffect(() => {
    setShowSeek(seek);
  }, [seek])

  useEffect(() => {
    if (user && account) {
      userRoleService.initialise(user, account);
      subscriptionPlanService.initialise(account);
      
      if(isCleverStoryIntegrated && _.size(activatedWorkSpaces) === 0){
        dispatch(fetchActivatedWorkSpaces()); 
      }
      applyColorThemes(account);
    }
  }, [user, account]);

  const opacityTransitionHeader = useTransition(!hideSideMenu, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1, config: { duration: 300 } },
    leave: { opacity: 0, config: { duration: 300 } },
  });

  const opacityTransitionCompose = useTransition(showComponent, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  if (!authenticated) {

    const params = new URLSearchParams(location.search);
    const redirectUrl = params.get("url") || location.pathname;

    return <Navigate to={`/public/login?redirect=${redirectUrl}`} />;
  }

  if (!(user && account)) {
    return <div className={styles.loading}>Loading Application...</div>;
  }
  
  const handleClick = () => {
    setExpanded(false); 
    setShowComponent(true);
  };

  const applyColorThemes = (account:Account) => {
    const root = document.documentElement;
    const primaryColor = _.get(account, 'theme.primaryColor', '#E51058');
    root.style.setProperty('--primaryColor', primaryColor);
    root.style.setProperty('height', '100vh');
    root.style.setProperty('overflow', 'hidden');
  }

  return (
    <AppContextProvider>
      <TourWatcher />

        <div className={styles.app}>
          <div className={styles.header}>
            <div className={cx(styles.menuWrapper, { [styles.expanded]: expanded })}>
              <MainMenu toggleCompose={handleClick} isDisabled={showSeek} expanded={expanded} setExpanded={setExpanded} />
            </div>
            <GradientBackground showGradient={showSeek && !(seekSessionChats?.length > 0)} />
            {showSeek && <div className={styles.seekAnchor}>
              <Seek onClose={() => dispatch(toggleSeek())} />
            </div>}
            <div
              // Note: Update this ID in all instances where it is used
              id="app-body"
              className={cx(styles.body, {
                [styles.fullWidth]: isLiteAssetView || hideSideMenu,
                [styles.disableScroll]: showSeek,
                [styles.sideMenuExpanded] : expanded && !showSeek,
                [styles.settingsActive] : activeModule === "settings",
              })}
            >
              {account && _.get(account,"theme.customStyleSheet") &&
                <Helmet key="1">
                  <link href={_.get(account,"theme.customStyleSheet")} rel="stylesheet" />
                </Helmet>
              }
              <Routes>
                <Route path="/" element={<ProtectedRoute />} >
                <Route path="/home" element={<Home />} />
                <Route path="/activate/success" element={<Activation />} />
                <Route path="/hub" element={<Hub />} >
                  <Route path="/hub/layout/:layoutId" element={<Hub />} />
                </Route>
                <Route
                  path="/assets/update-asset/:id"
                  element={<CreateAsset />}
                />
                <Route
                  path="/hub/create-asset/:type"
                  element={<CreateAsset />}
                />

                <Route path="/hub/content-map" element={<ContentMap />} >
                  <Route path=":id" element={<ContentMap />} />
                  <Route path="cluster/:id" element={<ContentMap />} />
                </Route>

                <Route path="/assets">
                  <Route path="/assets/:assetId" element={<AssetView />} />
                  <Route
                    path="/assets/office/:assetId"
                    element={<MicrosoftWopiIntegration />}
                  />
                   <Route path="/assets/:assetId/finish-editing" element={<MicrosoftWopiIntegrationProcessingPage />} />
                  <Route
                    path="/assets/gdoc/:assetId"
                    element={<GDocEditor />}
                  />
                  <Route
                    path="/assets/gdoc/:assetId/finish-editing"
                    element={<GDocEditorProcessing />}
                  />
                </Route>
                <Route path="/streams/:id" element={<StreamView />} />
                <Route path="/groups/:id" element={<GroupView />} />
                <Route path="/collections" element={<CollectionsPage />}>
                  <Route path="/collections" element={<CollectionsGrid />} />
                  <Route
                    path="folders/:folderId"
                    element={<CollectionsGrid />}
                  />
                </Route>
                
                <Route path="/coaching/*" element={<CoachingPage />} />
                <Route path="/scenarios">
                  <Route path="/scenarios/:id" element={<ScenarioPage />} />
                </Route>   
                <Route path="/reports" element={<Reports />}>
                  <Route path="discovery" element={<DiscoveryReport />} />
                  <Route path="engagement" element={<EngagementReport />} />
                  <Route path="performance" element={<PerformanceReport />} />
                  <Route path="advocacy" element={<AdvocacyTab />} />
                </Route>
                <Route path="/search" element={<SearchPage />} />
                <Route path="search/:page" element={<DetailedSearchPage />} />
                <Route path="/hub/search" element={<HubSearchPage />} />
                <Route
                  path="/hub/search/:page"
                  element={<HubDetailedSearchPage />}
                />

                <Route
                  path="/streams/:id/search"
                  element={<StreamSearchPage />}
                />
                <Route
                  path="/streams/:id/search/:page"
                  element={<StreamDetailedSearchPage />}
                />
                <Route path="/collections/uncategorized" element={<UncategorizedCollectionPage />} />
                <Route path="/collections/:id" element={<CollectionPage />}>
                  <Route
                    path="/collections/:id/sections/:sectionId"
                    element={<CollectionPage />}
                  />
                </Route>
                <Route path="/conversations" 
                element={<Conversations/>}
                >
                  <Route
                    path="/conversations/:id"
                    element={<Conversations/>}
                  />
                </Route>

                <Route path="/shares"
                    element={<Conversations />}
                >
                  <Route
                      path="/shares/:id"
                      element={<Conversations />}
                  />
                </Route>

                <Route
                    path="/deal-room/:id/"
                    element={<DealRoom />}
                  >
                    <Route path="/deal-room/:id/overview" element={<OverView />} />
                    <Route path="/deal-room/:id/assets/:type" element={<AssetsPage />} />
                    <Route
                      path="/deal-room/:id/assets/internal/sections/:sectionId"
                      element={<AssetsPage />}
                    />

                    <Route 
                      path="/deal-room/:id/people/:type"
                      element={<PeoplePage/>}/>
                    <Route path="/deal-room/:id/activity" element={<ActivityPage />} />

                    <Route
                      path="/deal-room/:id/engage"
                      element={<DealRoomEngagePage />} />
                    <Route
                      path="/deal-room/:id/engage/:conversationId"
                      element={<DealRoomEngagePage />} />
                    <Route path="/deal-room/:id/action-plan" element={<ActionPlanPage />} />
                  </Route>
                <Route path="/deal-rooms" element={<DealRooms />} />
                <Route path="/deal-rooms/:filterId" element={<DealRooms />} />

                {!isLiteApp && <>
                  <Route path="/settings/*" element={<SettingsRoutes />} />
                  <Route path="/privacy" element={<PrivacyView />}/>

                  <Route path="/engage" element={<EngagePage />} />
                    <Route path="/engage/:id" element={<EngagePage />} />

                  <Route path="/deal-insights" element={<DealInsightsDashboard />} />
                  <Route
                    path="/deal-insights/:id"
                    element={<DealDetailsView />}
                  />
                </>}

                <Route
                  path="/conversations/:id/edit"
                  element={<EditConversationPage />}
                />
                <Route
                  path="/conversations/:id/sections/:sectionId/edit"
                  element={<EditConversationPage />}
                />

                <Route path="*" element={<PageNotFound />} />
                  <Route
                    path="/redirect"
                    element={<ReferralRedirectView />}
                  />
                </Route>
              </Routes>
            </div>
            <div>
              <AppServices />
            </div>
          </div>
          <Outlet />

          {opacityTransitionCompose(
            (style, item) =>
              item && (
                <animated.div style={style} className={styles.revealCompose}>
                  <ComposePage
                    page={true}
                    onFinish={() => setShowComponent(false)}
                    onClose={() => setShowComponent(false)}
                  />
                </animated.div>
              ),
          )}

        </div>
        <BackgroundUploadTaskManager />
        <ToastContainer
          position={"bottom-right"}
          pauseOnHover
          theme="light"
          transition={Bounce}
          className={styles.toastContainer}
          closeButton={false}
          hideProgressBar={true}
        />
    </AppContextProvider>
  );
};


const ProtectedRoute = ({ }) => {
  const location = useLocation();
  const route = location.pathname.split("/")[1];

  if(!userRoleService.isInitialized() || !subscriptionPlanService.isInitialized()){
    return <div className={styles.loading}>Loading Application...</div>;
  }

  return hasAccess(route) ? (
      <Outlet />
  ) : (
    <div className={styles.accessRestricted}>
      <EmptyMessage
        width="auto"
        image={'/images/no_access.svg'}
        heading="No access!"
        message="Oops! You do not have access to this module."
      />
    </div>
  );
};

const getLiteAppRoutes = () => {
  return (
    <>
      <Route path="/liteAssetView/:assetId"
        element={<LiteAssetView />}
      />

      <Route
        path="/analytics"
        element={<AssetShareAnalyticsContainer />}
      />

      <Route
        path="/opportunities/analytics"
        element={<OpportunityAssetShareAnalyticsContainer />}
      />

      <Route
        path="/contacts/:email/conversations"
        element={<ContactConversationsContainer />}
      />

       <Route
        path="/hubspot/contacts/:email/conversations"
        element={<HubspotContactConversationsContainer />}
      />

      <Route
          path="/hubspot/opportunities/:opportunityId/recommended-assets"
          element={<RecommendedAssets />}
        />

      <Route
          path="/hubspot/opportunities/:opportunityId/shares"
          element={<HubspotOpportunitySharesContainer />}
        />
      <Route path='/opportunities' element={<Opportunities />}>
     
        <Route
          path="/opportunities/:opportunityId/shares"
          element={<OpportunitySharesContainer />}
        />
        <Route
          path="/opportunities/:opportunityId/recommended-assets"
          element={<OpportunityRecommendedAssetsContainer />}
        />
        <Route
          path="/opportunities/:opportunityId/recommended-streams"
          element={<OpportunityRecommendedStreamContainer />}
        />
        <Route
          path="/opportunities/*"
          element={<></>}
        />
      </Route>

      <Route path='/msdynamics/opportunities' element={<Opportunities />}>
        <Route
          path="/msdynamics/opportunities/:opportunityId/recommended-assets"
          element={<MsDynamicsOpportunityRecommendedAssetsContainer />}
        />
        <Route
          path="/msdynamics/opportunities/*"
          element={<></>}
        />
      </Route>

      <Route
        path={"/reports/unique-viewers"}
        element={<UniqueViewersContainer />}
      />

      <Route
        path={"/reports/conversations"}
        element={<ShareViewContainer />}
      />

      <Route
        path={"/reports/assets"}
        element={<AssetViewContainer />}
      />

      <Route
        path={"/reports/leads"}
        element={<LeadViewContainer />}
      />

      <Route
        path="/assets/:assetId/docusign/signing-complete"
        element={<DocusignSigningComplete />}
      />
    </>
  );
}

export default App;